import { render } from "./LeaveMelati.vue?vue&type=template&id=8806d2c8&scoped=true&ts=true"
import script from "./LeaveMelati.vue?vue&type=script&lang=ts"
export * from "./LeaveMelati.vue?vue&type=script&lang=ts"

import "./LeaveMelati.vue?vue&type=style&index=0&id=8806d2c8&lang=scss&scoped=true"

import exportComponent from "/Users/martjan/repositories/q-42/virtueel-indisch-monument/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8806d2c8"]])

export default __exports__